import type { AirportRecommend } from "../flightAirportInterface";

export class AirportRecommendClass implements AirportRecommend {
  code: string = "";

  countSearch: number = 0;

  name: string = "";

  constructor(data?: AirportRecommend) {
    if (!data) return;
    this.code = data?.code ?? this.code;
    this.countSearch = data?.countSearch ?? this.countSearch;
    this.name = data?.name ?? this.name;
  }
}
